<template v-editable="blok">
	<component
		:is="isInternalLink ? AbsoluteInternalLink : 'a'"
		:href="blok.value.cached_url"
		:target="blok.value.target"
		class="btn"
	>
		<NuxtIcon
			v-if="hasIconLeft"
			:name="hasIconName ? hasIconName : 'custom/arrow-right'"
			filled
			class="text-2xl"
			:class="hasIconClass"
		/>
		{{ blok.label }}
		<NuxtIcon
			v-if="hasIcon"
			:name="hasIconName ? hasIconName : 'custom/arrow-right'"
			filled
			class="text-2xl ml-2 -mr-2"
			:class="hasIconClass"
		/>
	</component>
</template>

<script setup lang="ts">
	import type {LinkBlockStoryblok} from '@/storyblok/types';

	type Props = {
		blok: LinkBlockStoryblok;
		hasIcon?: boolean;
		hasIconLeft?: boolean;
		hasIconName?: string;
		hasIconClass?: string;
	};

	const props = defineProps<Props>();

	const AbsoluteInternalLink = resolveComponent('AbsoluteInternalLink');

	const isInternalLink = computed(() => props.blok.value.linktype === 'story');
</script>
